export default "__VITE_ASSET__DRBP2B8Z__"